import { introQuestions } from "./introQuestions";
import { urinalysisQuestions } from "./urinalysisQuestions";
import { msdQuestions } from "./msdQuestions";
import { skinQuestions } from "./skinQuestions";
import { havsQuestions } from "./havsQuestions";
import { generalAndConsentQuestions } from "./generalAndConsentQuestions";
import { audiometryQuestions } from "./audiometryQuestions";
import { spirometryQuestions } from "./spirometryQuestions";
import { visionQuestions } from "./visionQuestions";
import { biologicalMonitoringQuestions } from "./biologicalMonitoringQuestions";
import { manualHandlingMSKQuestionnaireQuestions } from "./manualHandlingMSKQuestionnaireQuestions";

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const questions = [
    ...introQuestions,
    ...urinalysisQuestions,
    ...msdQuestions,
    ...skinQuestions,
    ...havsQuestions,
    ...audiometryQuestions,
    ...spirometryQuestions,
    ...visionQuestions,
    ...biologicalMonitoringQuestions,
    ...generalAndConsentQuestions,
    ...manualHandlingMSKQuestionnaireQuestions
];
